import React from "react";
import { Link, Head, useForm } from "@inertiajs/inertia-react";
import logo from "../../images/logo.png";
import Input from "@/Components/Input";
import Label from "@/Components/Label";
import Button from "@/Components/Button";
import ApplicationLogo from "@/Components/ApplicationLogo";

export default function Welcome({store, branchOffice, scheduleType, date, quantity, ...props}) {
    const { data, setData, processing, errors, reset, get } = useForm({
        // adults: adults,
        // children: children,
        quantity,
        date,
    });

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.value);
    };

    const submit = (e) => {
        e.preventDefault();
        get(route("schedule.search", {
            office: branchOffice.slug,
            scheduleType: scheduleType.id
        }));
    };

    const disabled = (scheduleType.is_group ? data.quantity < scheduleType.min_group_count : data.quantity < 1) || data.date == "";

    return (
        <>
            <Head title="Compra de tickets - Cerogrado" />
            <div className="relative flex items-top justify-center min-h-screen bg-gray-100 sm:items-center sm:pt-0">
                <div className="max-w-6xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-4">
                    <div className="flex justify-center pt-8 sm:pt-0">
                        {/* <img src={logo} className="h-16 w-auto sm:h-20" /> */}
                        <ApplicationLogo store={store} />
                    </div>

                    <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                        <h1 className="mb-4 text-center text-gray-900 text-lg font-bold">
                            Cuantos tickets vas a llevar?
                        </h1>

                        <form onSubmit={submit}>
                            <div>
                                <Label
                                    forInput="quantity"
                                    value="Número de tickets"
                                />
                                <Input
                                    type="number"
                                    min={scheduleType.is_group ? scheduleType.min_group_count : 1}
                                    name="quantity"
                                    value={data.quantity}
                                    className="mt-1 block w-full"
                                    isFocused={true}
                                    required={true}
                                    handleChange={onHandleChange}
                                />
                                <p className="mt-1 text-xs text-gray-500">
                                    Compra de tickets para personas que utilicen
                                    juegos o trampolines hasta 120 kgs de peso.
                                    {scheduleType.is_group ? ` Este ticket grupal debe tener al menos ${scheduleType.min_group_count} tickets` : ''}
                                </p>
                            </div>

                            <div className="mt-4">
                                <Label
                                    forInput="date"
                                    value="¿Cuándo quieres ir?"
                                />
                                <Input
                                    type="date"
                                    name="date"
                                    value={data.date}
                                    className="mt-1 block w-full"
                                    required={true}
                                    handleChange={onHandleChange}
                                />
                            </div>

                            <div className="flex items-center justify-center mt-8">
                                <Button processing={processing || disabled}>
                                    Buscar
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}
